import { AxiosAdapter } from "@/core/services/AxiosAdapter";
import { financasBaseUrl } from "@/core/services/protocols";
import { injectable, inject, optional } from "inversify";
import type { IHttpTokenInterceptor } from "@/core/services/middleware/HttpTokenInterceptor";
import type { AxiosInstance } from "axios";
import { DITypes } from "@/core/@types/types";
import type { IEvent } from "@/core/plugins/Events/Event";
@injectable()
export default class FinancasHttpClient extends AxiosAdapter {
  constructor(
    @inject(DITypes.EVENT) event: IEvent,
    @inject(DITypes.INTERCEPTOR)
    @optional()
    axiosTokenInterceptor?: IHttpTokenInterceptor<AxiosInstance>
  ) {
    super(event, axiosTokenInterceptor);

    this.setup(financasBaseUrl, false, false);
  }
}
